import React from 'react';
import classNames from 'classnames';
import styles from './style.less';

export const BadgeGroup = ({ children, className, ...props }) => (
  <span className={classNames(styles.badgeGroup, className)} {...props}>
    {children}
  </span>
);

export default ({ text, status, type, absolute, top, right, className, ...props }) => {
  return (
    <div
      {...props}
      className={classNames(
        styles.badge,
        styles[status],
        styles[type],
        className,
        absolute ? styles.absolute : '',
        top ? styles.top : '',
        right ? styles.right : '',
      )}
    >
      <span>{text}</span>
    </div>
  );
};
